export const commons = {
  languages: {
    A1: 'A1 - Başlangıç',
    A2: 'A2 - ortalamanın altında',
    B1: 'B1 orta',
    B2: 'B2 - ortalamanın üstünde',
    C1: 'C1 - Gelişmiş',
    C2: 'C2 profesyonel',
    Native: 'Ana dil'
  },
  roles: {
    club: 'Kulüp',
    artist: 'Sanatçı',
    admin: 'Yönetici'
  },
  artistJobs: {
    Hostess: 'Hostes',
    GoGo: 'Gogo',
    Strip: 'Şerit'
  },
  schedule: {
    Monday: 'Pazartesi',
    Tuesday: 'Salı',
    Wednesday: 'Çarşamba',
    Thursday: 'Perşembe',
    Friday: 'Cuma',
    Saturday: 'Cumartesi',
    Sunday: 'Pazar'
  },
  paymentFrequency: {
    Daily: 'Gün',
    Weekly: 'Hafta',
    Monthly: 'Ay'
  },
  flightPaymentType: {
    Club: 'Kulüp pahasına',
    Artist: 'Sanatçı pahasına',
    Credit: 'Borç verme',
    Agreement: 'Anlaşma yoluyla',
    Compensation: 'Tazminat'
  },
  artistConsumation: {
    label: 'Tüketme',
    Active: 'Aktif',
    Passive: 'Pasif'
  },
  workItemType: {
    Request: 'Başvuru',
    Invite: 'Davet'
  },
  workItemStatus: {
    Pending: 'Beklemek',
    Accepted: 'Kabul edilmiş',
    Rejected: 'Reddedilmiş',
    Withdrawn: 'Ortaya çıkarmak',
    Expired: 'Kolaylaştırılmış',
    ContractOngoing: 'Sözleşme geçerlidir',
    ContractRequestedEndDate: 'Sözleşmenin tarihini istedi',
    FinishingContract: 'Sözleşme biter',
    ContractCompleted: 'Sözleşme tamamlandı',
    ClubSetEndDate: 'Kulüp bitiş tarihini belirledi',
    Cancelled: 'İptal edilmiş'
  },
  artistStatuses: {
    LookingForWork: 'Aramada',
    OnContract: 'Sözleşmede',
    FinishingContract: 'Sözleşmeyi bitiriyorum',
    OnVacation: 'İzinli',
    HiddenFromSearch: 'Aramadan gizlenmiş'
  },
  loading: {
    generic: 'Veriler yüklendi ...',
    requests: 'Uygulamalar yüklendi ...',
    invites: 'Davetiyeler yüklendi ...'
  },
  flightCompensationOptions: {
    oneMonth: '1 aylık sözleşme için',
    twoMonths: '2 aylık sözleşme için',
    threeMonths: '3 aylık sözleşme için',
    sixMonths: 'Sözleşmenin 6 ayı boyunca kulüp bir dönüş bileti alıyor',
    backTicket: 'Dönüş Bileti'
  },
  transportFromAirport: {
    label: 'Havaalanından/istasyondan ulaşım',
    options: {
      clubOrganizes: 'Kulübü organize ediyor',
      artistSelf: 'Sanatçı kendini alır'
    }
  },
  notFound: {
    generic: 'Kayıt boş.',
    requests: 'Henüz uygulama yok.',
    invites: 'Henüz davet yok.',
    artists: 'Şu anda sanatçıların listesi boş',
    search:
      'Kulübü isteğinize göre bulamadık: (Aramayı daha iyi hale getirebilmemiz için lütfen bu konuda rapor rapor edin'
  },
  artistParametres: {
    weight: 'Ağırlık',
    height: 'Yükseklik',
    body: 'Vücut',
    chest: 'Göğsün çılgınlığı',
    waist: 'Bel çevresi',
    hips: 'Kalçaların kalçaları'
  },
  dressCodeOptions: {
    strip: 'Şeritler',
    underwear: 'İç çamaşırı',
    longDress: 'Uzun elbise',
    body: 'Vücut',
    shortDress: 'Kısa elbise'
  },
  time: {
    years:
      '{count, plural, one {# yıl} few {# yıl} many {# yıl} other {# yıl}}',
    months:
      '{count, plural, one {# ay} few {# aylar} many {# aylar} other {# aylar}}',
    days: '{count, plural, one {# gün} few {# Gün} many {# günler} other {# Gün}}'
  },
  contact_support: 'Yardıma mı ihtiyacınız var? Destek ile iletişime geçin',
  success_send_data: 'Veriler başarıyla gönderildi',
  show_full: 'Tamamen göster',
  worked_for: 'Çalıştı (a)',
  club_reviews: 'Kulüp hakkında incelemeler',
  club_response: 'Kulüp yanıtı',
  response: 'Cevap',
  send: 'Göndermek',
  cm: 'santimetre',
  kg: 'kilogram',
  no_rating_yet: 'Henüz derecelendirme yok',
  rating_allow:
    'Sanatçılar kulübü ancak 21 günlük işten sonra değerlendirebilir',
  rating: 'derecelendirme',
  rating_popup_header_1: 'Kulüpteki sözleşmeniz',
  rating_popup_header_2: 'Tamamlanmış',
  contractWeeks:
    '{count, plural, one {# hafta} few {# haftalar} many {# haftalar} other {# haftalar}}',
  rating_popup_text:
    'Biz ve diğer sanatçıların bu yer hakkındaki fikrinizi bilmeleri önemlidir. Lütfen bu kulüpteki çalışmaları değerlendirin.',
  error_rating: 'Derecelendirme hatası',
  no_rating:
    'Bu kulübü değerlendirmek için bir unsur yoktur veya zaten değerlendirilmiştir',
  housing_quality: 'Konut kalitesi',
  dressing_quality: 'Giyinme odasının kalitesi',
  management: 'Rehber ve Personel',
  anonymous: 'İncelemeyi anonim olarak bırakın',
  rate_work: 'Değerlendirme, bu kulüpte çalışmak',
  submit: 'Göndermek',
  years: 'yıl',
  allow_note: 'Bildirimlere izin ver',
  allow_note_1:
    'Önemli olayları kaçırmamak için platformun doğru çalışması için bildirimlere izin verin:',
  allow_note_2: 'Uygulamalar ve Davetiyeler',
  allow_note_3: 'Kulüplerden Cevaplar',
  allow_note_4: 'Sanatçılardan veya yöneticilerin mesajları',
  allow_note_5: 'Sadece iş bildirimleri gönderiyoruz - spam yok.',
  'follow-us-in-social': 'Bizi sosyal ağlarda takip edin:',
  continue: 'Devam etmek',
  'continue-with-google': "Google'a devam edin",
  artistHiringIsOpen: 'Bir dizi sanatçı açık',
  artistHiringIsClosed: 'Sanatçı seti kapalı',
  acceptWithExperience: 'Deneyimsiz kabul ediyoruz',
  dontAcceptWithoutExperience: 'Deneyimsiz kabul etmiyoruz',
  info: 'Bilgi',
  copyLink: 'Bağlantıyı kopyalayın',
  withExperience: 'Deneyimli',
  withouthExperience: 'Deneyimsiz',
  agree: 'Koşullara katılıyorum',
  change: 'Değiştirmek',
  add: 'Eklemek',
  citizenship: 'Vatandaşlık',
  selectCountry: 'Ülkeyi Seçin',
  save: 'Kaydetmek',
  'save-and-continue': 'Kaydet ve Devam Edin',
  edit: 'Düzenlemek',
  portfolio: 'Portföy',
  close: 'Kapalı',
  closed: 'Kapalı',
  finish: 'Tamamlamak',
  help: 'Yardım',
  logout: 'Dışarı çıkmak',
  country: 'Ülke',
  place: 'Konum',
  deleteAccount: 'Bir Hesabı Sil',
  changePassword: 'Şifre değiştir',
  hide: 'Saklamak',
  delete: 'Silmek',
  exit: 'Evet, dışarı çıkmak istiyorum',
  'undo-to-account': 'Hesaba geri dön',
  location: 'Konum',
  language: 'Diller',
  reviews: 'İncelemeler',
  parametres: 'Parametreler',
  about: 'Kendin Hakkında',
  my: 'Benim',
  photo: 'Fotoğraf',
  video: 'Video',
  experience: 'Deneyim',
  galery: 'Galeri',
  write: 'Yazmak',
  yes: 'Evet',
  step: 'Adım',
  no: 'HAYIR',
  or: 'Veya',
  resend: 'Göndermek',
  open: 'açık',
  cancel: 'İptal etmek',
  need: 'İhtiyaç',
  dontNeed: 'İhtiyaç duyulmadı',
  endWork: 'İşin sonu',
  startDate: 'İşin başlangıç ​​tarihi',
  endDate: 'İşin sonu',
  vacancy: 'Boşluk',
  creditation: 'Bilet kredisi',
  aroundTheClock: 'Saat',
  flightTickets: 'Uçuş',
  ticketCreditation: 'Bilet kredisi',
  crazyMenu: 'Çılgın Menü',
  tea: 'Çay',
  show: 'Göstermek',
  deposit: 'Yatırmak',
  guarantee: 'Garanti',
  rate: 'Teklif etmek',
  clubFee: 'Kulüp ücreti',
  separated: 'Ayırmak',
  forShift: 'Vardiyalar için',
  required: 'Zorunlu olarak',
  optional: 'Mutlaka değil',
  quantity: 'Miktar',
  withouthExprience: 'Deneyimsiz',
  choreographerInClub: 'Kulüpte bir koreografın varlığı',
  photoshootParticipation: 'Fotoğraf çekimlerine katılım',
  artistsInShift: 'Vardiyadaki Sanatçılar',
  scenes: 'Sahneler',
  dynamicPole: 'Pilon Dinamiği',
  staticPole: 'Pilon Statics',
  artistTraining: 'Sanatçıların Eğitimi',
  teching: 'Eğitim',
  dressCodeForArtists: 'Sanatçılar için kıyafet kodu',
  dressCode: 'Kıyafet kodu',
  rentPayment: 'Konut ödemesi',
  utilitiesPayment: 'Ortakların ödenmesi',
  clubProvidedAccommodation: 'Sanatçının kulüpten konutta konaklaması',
  housingPhoto: 'Konut fotoğrafı',
  noteEditLater: 'Daha sonra değişiklik yapabilirsiniz',
  paydByArtist: 'Sanatçı',
  paydByClub: 'Kulüp',
  peopleInRoom: 'Odadaki adam',
  uploadFromDevice: 'Cihazdan indir',
  uploadManyFromDevice: 'Cihazdan birkaç fotoğraf yükleyin',
  selectMainPhoto: 'Ana fotoğrafı seçin',
  photoParams: "Fotoğrafın boyutu __var_0__ mb'yi geçmemelidir",
  videoParams:
    "Videonun boyutu __var_0__ mb'yi aşmamalıdır, desteklenen formatlar: MP4, QuickTime,",
  general: 'Genel',
  payments: 'Ödemeler',
  full: 'Tam dolu',
  topless: 'Toplu',
  gogo: 'Go-moh',
  crazymenu: 'Çılgın Menü',
  continueFilling: 'Dolmaya devam et',
  exitShort: 'Çıkış',
  search: 'Arama',
  other: 'Diğer',
  foreignLanguages: 'Yabancı diller',
  dancer: 'Dansçı',
  untilNow: 'Bugüne kadar',
  invite: 'Davet etmek',
  cancelInvite: 'Davetiyeyi iptal et',
  dateFormatPlaceholder: 'Dd.mm.yy',
  askArtist: 'Sanatçıya bir soru sor',
  askClub: 'Kulübe bir soru sorun',
  reject: 'Reddetmek',
  accept: 'Kabul etmek',
  confirm: 'Onaylamak',
  iConfirm: 'Onaylamak',
  workAt: 'İle çalışmak',
  setLastDate: 'Son tarihi ayarlayın',
  lastWorkDay: 'İşin son günü',
  cancelArrangement: 'Sözleşmeyi iptal et',
  back: 'Geri',
  wantedVacancy: 'İstenen boş pozisyonlar',
  addClub: 'Kulübü ekle',
  goToInvitation: 'Davetiye Git',
  goToRequest: 'Talebe Git',
  vacancyConsider: 'Hangi boş pozisyonları düşünüyorsunuz?',
  super: 'Süper',
  clubLocation: 'Kulübün yeri',
  specify: 'Belirtmek',
  housing: 'Konut',
  position: 'Konum',
  guest: 'Misafir',
  workingHours: 'Açılış saatleri',
  isPaydByClub: 'Kulüp tarafından ödenmiş',
  isntPaydByClub: 'Kulüp tarafından ödenmiyor',
  utilityPayments: 'Kamu hizmetlerinin ödenmesi',
  payment: 'Ödeme',
  request: 'Rica etmek',
  penalties: 'Para cezası',
  aboutClub: 'Kulüp hakkında',
  sendRequest: 'Uygula',
  cancelRequest: 'Uygulamayı iptal et',
  profile: 'Profil',
  chat: 'Sohbet',
  housigInClubApartsRequired: 'Kulüpten konutta konaklama gereklidir'
};
